import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { RosterstreamProviderType } from 'libs/domain';

@Component({
  selector: 'mg-rosterstream-ui',
  templateUrl: './rosterstream-ui.component.html',
  styleUrls: ['./rosterstream-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RosterstreamUiComponent {
  constructor() {}

  @Input() providers: RosterstreamProviderType[] = [];
  @Output() initiateLogin: EventEmitter<RosterstreamProviderType> = new EventEmitter();

  public async providerClicked(type: RosterstreamProviderType) {
    this.initiateLogin.emit(type);
  }
}
